import * as Yup from "yup";

const schema = Yup.object().shape({
  documentType: Yup.string().required("Tipo de documento é obrigatório"),

  document: Yup.string()
    .required("Número do documento é obrigatório")
    .when("documentType", {
      is: "CPF",
      then: schema =>
        schema.matches(
          /^\d{11}$/,
          "CPF inválido. Deve conter 11 dígitos numéricos"
        )
    })
    .when("documentType", {
      is: "CNPJ",
      then: schema =>
        schema.matches(
          /^\d{14}$/,
          "CNPJ inválido. Deve conter 14 dígitos numéricos"
        )
    })
    .when("documentType", {
      is: "PLATE",
      then: schema =>
        schema.matches(
          /^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/,
          "Placa inválida. Use o formato ABC1234 ou ABC1D23"
        )
    })
    .when("documentType", {
      is: "PHONE",
      then: schema =>
        schema.matches(
          /^\d{10,11}$/,
          "Telefone inválido. Informe DDD + número, apenas números (10 ou 11 dígitos)"
        )
    }),

  queryTypes: Yup.array()
    .of(Yup.number())
    .min(1, "Selecione pelo menos um tipo de consulta"),

  observation: Yup.string().optional(),

  active: Yup.boolean().required()
});

export default schema;
